module.exports = __webpack_public_path__ + "img/j-shanxi.7ccd85e9.jpg";